import iconChatSubmit from "../../../../assets/icon_chat_submit.svg";
import { FiPlus } from "react-icons/fi";
import FAQModal from "../Modal/FAQModal";
import { useLocation } from "react-router-dom";
import useFAQ from "../../hooks/bot/useFAQ";
import { useState } from "react";

const Input = ({ onKeyDown, onKeyUp, onSendButtonClick, inputRef, search }) => {
  const [modalIsOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const { realtiemList, questionList, handleOnClick } = useFAQ({
    search,
    closeModal,
  });
  const { pathname } = useLocation();
  return (
    <>
      <div className="fixed bottom-0 left-0 flex items-center justify-between w-full py-3 px-3  bg-white shadow-2xl gap-2.5 ">
        {pathname === "/chat" && (
          <button onClick={() => openModal()}>
            <FiPlus className="text-3xl" />
          </button>
        )}

        <div className="flex-1 ">
          <label className="flex items-center gap-2 bg-neutral-100 input rounded-[60px]">
            <input
              ref={inputRef}
              type="text"
              className="w-full"
              placeholder="궁금한 사항을 입력해 주세요"
              onKeyDown={onKeyDown}
              onKeyUp={onKeyUp}
            />
            <button
              onClick={() => {
                setTimeout(() => {
                  onSendButtonClick();
                }, 10);
              }}
            >
              <img src={iconChatSubmit} alt="" />
            </button>
          </label>
        </div>
      </div>
      <FAQModal
        realtiemList={realtiemList}
        questionList={questionList}
        search={search}
        handleOnClick={handleOnClick}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
      />
    </>
  );
};

export default Input;
